<template>
  <vue-final-modal
    v-slot="{ params, close }"
    v-bind="$attrs"
    classes="modal-container"
    content-class="modal-content"
    :click-to-close="true"
    :esc-to-close="true"
    :styles="pageYStyles"
    :z-index-base="2000"
  >
    <span class="modal__title">
      <slot name="title"></slot>
    </span>
    <div class="modal__content">
      <slot :params="params"></slot>
    </div>
    <div class="modal__action">
      <slot name="actions"></slot>
    </div>
    <button
      type="button"
      class="btn-close modal__close"
      @click="close"
    ></button>
  </vue-final-modal>
</template>

<script>
export default {
  name: "SetOffsetModal",
  inheritAttrs: false,
  emits: ["confirm", "cancel", "clear"],
  props: ["pageY"],
  computed: {
    pageYStyles() {
      return this.pageY && this.$route?.query?.iframe
        ? {
            paddingTop: `${this.pageY - 30}px`,
            alignItems: "start",
          }
        : {};
    },
  },
};
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  max-width: 540px;
  margin-left: 1rem;
  margin-right: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  padding: 1rem;
  font-size: 1.2rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-shrink: 0;
  padding: 0;
}
.modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>

<style scoped>
.dark-mode div ::v-deep(.modal-content) {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
